import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";
import { format } from "date-fns";
import calenderIcon from "../../assets/icons/calendar.svg";
//import { useNavigate } from "react-router-dom";

const formatDate = (date) => {
  return format(date, "MMM dd, yyyy");
};

const GlobalStyles = createGlobalStyle`
  .rdrSelected, .rdrStartEdge, .rdrEndEdge, .rdrInRange {
    background: #03a9f4 !important;
  }
  .rdrDateDisplayItemActive {
    border-color: #03a9f4 !important;
}
.rdrStaticRangeSelected {
  color: #03a9f4 !important;
}
.rdrDayToday .rdrDayNumber span:after{
    background: #03a9f4 !important;
  }
  .rdrDayStartPreview {
  border-left: 1px solid #03a9f4 !important;
  border-top: 1px solid #03a9f4 !important;
  border-bottom: 1px solid #03a9f4 !important;
}
.rdrDayEndPreview {
  border-right: 1px solid #03a9f4 !important;
  border-top: 1px solid #03a9f4 !important;
  border-bottom: 1px solid #03a9f4 !important;
}
.rdrDayInPreview {
  border-top: 1px solid #03a9f4 !important;
  border-bottom: 1px solid #03a9f4 !important;
}
.rdrDayHovered {
  border: none !important;
}
`;

const DateRangePickerWrapper = styled.div`
  position: relative;
  display: inline-block;

  .date-display {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border: 1px solid #989fad;
    border-radius: 12px;
    cursor: pointer;
    color: #48505e;
    font-size: 14px;

    .icon {
      margin-right: 8px;
    }
  }

  .top {
    display: flex;

    button {
      margin-left: 8px;
      padding: 4px 8px;
      border-radius: 12px;
      background: #03a9f4;
      border: none;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }
  }

  .date-picker {
    position: absolute;
    top: 50px;
    right: 10px;
    z-index: 1000;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: ${(props) => (props.showPicker ? "block" : "none")};
  }
`;

const DateRangePickerComponent = ({ dateRange = {}, onDateChange }) => {
  //const navigate = useNavigate();

  const getInitialDateRange = () => ({
    startDate: new Date(),
    endDate: new Date(),
  });

  // Track if dates were provided initially via props
  const hasInitialDates = dateRange.startDate && dateRange.endDate;

  const [state, setState] = useState([
    {
      startDate: dateRange.startDate || getInitialDateRange().startDate,
      endDate: dateRange.endDate || getInitialDateRange().endDate,
      key: "selection",
    },
  ]);

  const [showPicker, setShowPicker] = useState(false);
  const wrapperRef = useRef(null);
  const [hasUserSelectedDates, setHasUserSelectedDates] = useState(hasInitialDates);

  // const isInitialRange = () => {
  //   const today = new Date();
  //   const initialEndDate = new Date();

  //   return (
  //     state[0].startDate.getDate() === today.getDate() &&
  //     state[0].startDate.getMonth() === today.getMonth() &&
  //     state[0].startDate.getFullYear() === today.getFullYear() &&
  //     state[0].endDate.getDate() === initialEndDate.getDate() &&
  //     state[0].endDate.getMonth() === initialEndDate.getMonth() &&
  //     state[0].endDate.getFullYear() === initialEndDate.getFullYear()
  //   );
  // };

  const isFiltered = () => {
    // If dates were provided initially or user has selected dates, show them
    return hasInitialDates || hasUserSelectedDates;
  };

  const [hasPickedStartDate, setHasPickedStartDate] = useState(false);

  const handleRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setState([ranges.selection]);

    if (!hasPickedStartDate) {
      setHasPickedStartDate(true); // First click
    } else {
      onDateChange({ startDate, endDate }); // Second click — selection complete
      setHasPickedStartDate(false); // Reset for next time
      setHasUserSelectedDates(true); // Mark that user has selected dates
    }
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Sync state when `dateRange` changes
  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      setState([
        {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          key: "selection",
        },
      ]);
      setHasUserSelectedDates(true);
    } else if (!dateRange.startDate && !dateRange.endDate) {
      // Reset to show "Filter by date range" if dateRange is cleared
      setHasUserSelectedDates(false);
    }
  }, [dateRange]);
  
  // const handleClear = () => {
  //   navigate(0);
  // };

  return (
    <>
      <GlobalStyles />
      <DateRangePickerWrapper ref={wrapperRef} showPicker={showPicker}>
        <div className="top">
          <div
            className="date-display"
            onClick={() => setShowPicker(!showPicker)}
          >
            <span className="icon">
              <img src={calenderIcon} alt="" />
            </span>
            <span>
              {isFiltered()
                ? `${formatDate(state[0].startDate)} - ${formatDate(
                    state[0].endDate
                  )}`
                : "Filter by date range"}
            </span>
          </div>
          {/* {!isInitialRange() && (
            <button onClick={handleClear}>Clear filter</button>
          )} */}
        </div>

        <div className="date-picker">
          <DateRangePicker
            ranges={state}
            onChange={handleRangeChange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            direction="horizontal"
          />
        </div>
      </DateRangePickerWrapper>
    </>
  );
};

export default DateRangePickerComponent;
